import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import ReactQuill from "react-quill";
import api from "../../api";
import Logo from "../../images/logo-2.png";
import "react-quill/dist/quill.snow.css";

function AdminForgetPass({ match }) {
  const [email, setEmail] = useState("");
  const [loader, setLoader] = useState(false);

  const handleSubmit = async () => {
    try {
      if (email) {
        setLoader(true);
        let payload = {
          email: email,
        };
        // console.log(payload);
        const userData = await api.forgetPass(payload);
        // console.log(userData);
        if (userData.success) {
          alert(userData.message);
          setLoader(false);
          setEmail("");
        } else {
          alert("Something went wrong, email not sent ");
          setLoader(false);
        }
        // console.log(value);
      } else {
        setLoader(false);
        alert("Please insert fields");
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
      alert("Something went wrong, email not sent ");
    }
  };

  return (
    <>
      {/* Begin Page Content */}
      <div className="container-fluid">
        {/* Content Row */}
        <div className="row">
          {/* Area Chart */}
          <div className="col">
            <div className="row mx-0 drivers-row">
              <div className="col-xl-6 col-md-7  d-flex justify-content-between pr-0">
                <h4 className="color-dark fs-17 dib font-weight-bold mr-5">
                  Send Forget Password Mail To User
                </h4>
              </div>
            </div>
            <div className="card sortby-box br-10 border-transparent mt-3">
              <div className="card-header br-10  bg-white border-transparent py-3 ">
                <div className="form-group mb-3">
                  <input
                    type="text"
                    className="form-control"
                    onChange={(e) => setEmail(e.target.value)}
                    value={email}
                    placeholder="Enter User Email..."
                  />
                </div>
                <div className="sendMailBtn mt-3">
                  <button onClick={handleSubmit} className="btn-dark">
                    Send Mail
                  </button>
                </div>
              </div>
            </div>
            {/* table */}
          </div>
        </div>
      </div>
      {/* /.container-fluid */}
      {loader && (
        <div className="seekoLoader">
          <div className="loader">
            <img src={Logo} alt="loader" />
          </div>
        </div>
      )}
    </>
  );
}

export default AdminForgetPass;
